<form (ngSubmit)="logIn()" [formGroup]="loginForm" class="login-form login-view-1" autocomplete="off">
  <h3 class="login-form-header">
    {{ 'login.welcome' | translate }}
    <span class="cc-login-mask" *ngIf="loading">
      <p-progressSpinner class="cc-table-spinner" strokeWidth="5" animationDuration="1s"></p-progressSpinner>
    </span>
  </h3>

  <div class="inputs">
    <div class="login-pwd">
      <div class="form-group is-invalid">
        <app-input-regular
          [autocomplete]="'off'"
          [controlForm]="loginForm.controls[LoginForm.FIELDS.LOGIN]"
          [displayErrorDynamic]="displayErrorDynamic"
          [placeHolder]="'login.username'"
          [typeInput]="'text'"
          [typeLabel]="'basic'">
        </app-input-regular>
      </div>
      <div class="login-password">
        <app-input-regular
          [autocomplete]="'off'"
          [controlForm]="loginForm.controls[LoginForm.FIELDS.PASSWORD]"
          [displayErrorDynamic]="displayErrorDynamic"
          [placeHolder]="'login.password'"
          [typeInput]="'password'"
          [typeLabel]="'basic'">
        </app-input-regular>
      </div>
    </div>
    <div *ngIf="getError(); let error" class="login-errors" [class.login-errors-warn]="alert?.status === Alert.Status.WARN">
      <div>{{ error }}</div>
      <button *ngIf="extractReferenceCode(error)"
              pButton pRipple type="button" icon="fa-solid fa-clipboard"
              class="p-button-text p-button-sm copy-reference-code-button"
              [cdkCopyToClipboard]="extractReferenceCode(error)"
              (cdkCopyToClipboardCopied)="copiedToClipboard()"
              pTooltip="Copy reference code">
        &nbsp;&nbsp;Copy reference code
      </button>
    </div>
  </div>

  <div class="login-button-container">
    <app-button [label]="'login.connect'" [disabled]="loading"></app-button>
    <div class="login-forgot">
      <a (click)="forgotPassword.emit()" class="cursor-pointer"
         title="{{ 'login.forgot_password' | translate }}">
        {{ 'login.forgot_password' | translate }}
      </a>
    </div>
  </div>
</form>
